module.exports = __webpack_public_path__ + "img/图1-22圆规及其附件.74aa2b7a.png";